import {
    Component,
    ViewEncapsulation,

} from '@angular/core';

@Component({
    selector: 'home-logged-loader',
    templateUrl: './home-logged-loader.component.html',
    styleUrls: ['./home-logged-loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomeLoggedLoaderComponent {
}
